import { useCallback, useEffect, useRef, useState } from "react";
import { getUnseenWebLeadsCount } from "../services/webLeads.api";

const REFRESH_MS = 10000;

/**
 * Alimenta el badge de "Agenda" en el menú lateral (mejora post-cierre,
 * 2026-09-21, a pedido del propietario probando en el VPS: "no sé si llegó
 * un lead nuevo, tengo que entrar a Solicitudes web a adivinar"). Mismo
 * criterio de polling que ya usa `AppointmentsWebLeads.js` (10s, pausado con
 * la pestaña oculta) — no hay evento de socket cuando nace un lead "nueva"
 * (solo cuando se convierte), así que el menú lateral se apoya en lo mismo
 * que ya usa la propia pestaña.
 *
 * Gateado por `showSchedules` en `localStorage` (mismo flag que ya usa
 * `AccordionMenu.checkConditional` para decidir si el ítem "Agenda" existe):
 * sin Agenda habilitada para la empresa, no tiene sentido preguntar por leads.
 */
export default function useWebLeadsUnseenCount() {
  const [count, setCount] = useState(0);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => { isMountedRef.current = false; };
  }, []);

  const fetchCount = useCallback(async () => {
    if (localStorage.getItem("showSchedules") !== "true") {
      if (isMountedRef.current) setCount(0);
      return;
    }
    try {
      const { data } = await getUnseenWebLeadsCount();
      if (isMountedRef.current) setCount(Number(data?.count) || 0);
    } catch {
      // Silencioso a propósito: es un poll de fondo del menú lateral, no una
      // acción del usuario — no hay dónde mostrar un error sin ser intrusivo.
    }
  }, []);

  useEffect(() => {
    fetchCount();
    const tick = () => {
      if (document.visibilityState === "visible") fetchCount();
    };
    const timer = setInterval(tick, REFRESH_MS);
    return () => clearInterval(timer);
  }, [fetchCount]);

  return count;
}
